<template>
    <ion-page>
      <ion-header :translucent="true">
        <ion-toolbar>
          <ion-buttons slot="start">
            <ion-menu-button color="primary"></ion-menu-button>
          </ion-buttons>
          <ion-title>Request IOU Back</ion-title>
        </ion-toolbar>
      </ion-header>
      
      <ion-content :fullscreen="true">
        <ion-header collapse="condense">
          <ion-toolbar>
            <ion-title size="large">Request IOU Back</ion-title>
          </ion-toolbar>
        </ion-header>
      
        <div id="container">
          <ion-item>
              <ion-label position="floating">Amount <span class="required">*</span></ion-label>
              <ion-input type="number"  v-model="amount"></ion-input>
          </ion-item>
          <ion-button expand="block" @click="save" color="success">Submit</ion-button>
          
        </div>
      </ion-content>
    </ion-page>
  </template>
  
  <script>
  import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonButton, IonItem, IonLabel, IonInput, alertController} from '@ionic/vue';
  
  export default {
    name: 'Request IOU Back',
    components: {
      IonButtons,
      IonContent,
      IonHeader,
      IonMenuButton,
      IonPage,
      IonTitle,
      IonToolbar,
      IonButton,
      IonItem,
      IonLabel,
      IonInput
    },
    data(){
        return {
          amount:null
        }
    },
    methods:{
        async save(){
          if(this.amount=="" || this.amount==null){
              this.presentAlert("amount");
              return;
          }
          const data={
              'amount':this.amount,
          };
          data['username'] = window.localStorage.username,
          data['password'] = window.localStorage.password,
        this.$http.post('requestIOUReimbursement',data).then(response=>{
          if(response.status==200){
              this.amount=null;
            this.presentResponseAlert('Success','IOU Back Request submitted successfully');
          }
        });      
      },
        async presentResponseAlert(type,message) {
        const alert = await alertController
          .create({
            header: type+'!',
            // subHeader: 'Subtitle',
            message: message,
            buttons: ['OK'],
          });
        await alert.present();
  
      },
      async presentAlert(message) {
        const alert = await alertController
          .create({
            header: 'Alert!',
            // subHeader: 'Subtitle',
            message: message+" is required",
            buttons: ['OK'],
          });
        await alert.present();
  
      },
    }
  }
  </script>
  
  <style scoped>
  
  #container strong {
    font-size: 20px;
    line-height: 26px;
  }
  
  #container p {
    font-size: 16px;
    line-height: 22px;
    color: #8c8c8c;
    margin: 0;
  }
  
  #container a {
    text-decoration: none;
  }
  </style>